module.exports = __webpack_public_path__ + "img/client-bia.546950b9.jpg";